import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Input from "../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import SuccessError from "../../SuccessError";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import OwnerAssignment from "../../OwnerAssignment";
import axiosInstance, { handleApiError } from "../../../../services/axiosService";
import OwnerAssignmentCard from "../../OwnerAssignmentCard";
import Button from "../../../../components/FormComponents/Button";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import FieldSelectorFromPopup from "../../../../components/BuilderComponents/FieldSelectorFromPopup";
import { useTableContext } from "../../../../context/TableContext";

const sortOrderOptions = [
  { id: "DESC", name: "DESC" },
  { id: "ASC", name: "ASC" }
];
const initialSidebarState = {
  isOpen: false,
  title: "",
  type: ""
};
const ActivitySettings = ({ activityForm, activityData, setActivityData }) => {
  // const [isRightbarOpen, setIsRightbarOpen] = useState(false);
  const [sidebarModal, setSidebarModal] = useState(initialSidebarState);
  const [allGroups, setAllGroups] = useState([]);
  // const [allCommunityGroups, setAllCommunityGroups] = useState([]);
  const [allRdbms, setAllRdbms] = useState([]);
  const { orgId, smId } = useParams();

  const openSidebar = (title, type) => {
    setSidebarModal({ isOpen: true, title, type });
  };

  const closeSidebar = () => {
    setSidebarModal(initialSidebarState);
  };

  const fetchAllGroups = async () => {
    try {
      const { data: groups } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
      // const { data: commGroups } = await axiosInstance.get(`/community-user-groups`);
      setAllGroups(groups);
      // setAllCommunityGroups(commGroups);
    } catch (error) {
      console.error("Error fetching all groups:", error);
      handleApiError(error);
    }
  };

  const fetchAllRdbmsTemplates = async () => {
    try {
      const { data } = await axiosInstance.get(`/rdbms`);
      const groupRdbms = data.filter((rdbms) => rdbms.is_group);
      setAllRdbms(groupRdbms);
    } catch (error) {
      handleApiError(error);
    }
  };

  const settingTypeChange = (e) => {
    const isChecked = e.target.checked;
    const newType = isChecked ? "init" : "default";
    setActivityData({ ...activityData, type: newType });
  };

  const handleChangeAllowedCount = (e) => {
    const newActivityData = { ...activityData };
    newActivityData.allowed_count = parseInt(e.target.value);
    setActivityData(newActivityData);
  };

  const handleChangeSortKey = (value) => {
    const newActivityData = { ...activityData };
    newActivityData.sort_by.key = value;
    setActivityData(newActivityData);
  };

  const handleChangeSortOrder = (value) => {
    const newActivityData = { ...activityData };
    newActivityData.sort_by.order = value;
    setActivityData(newActivityData);
  };

  const handleMessageChange = (data) => {
    const newActivityData = { ...activityData };
    newActivityData.activity_response = data;
    setActivityData(newActivityData);
  };

  const settingOwnerAssignment = (data) => {
    setActivityData({ ...activityData, activity_owner_assignment: data });
  };

  useEffect(() => {
    fetchAllGroups();
    fetchAllRdbmsTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log("activityData", activityData);
  return (
    <div style={{ height: "calc(100vh - 150px)", overflow: "auto", padding: "20px" }}>
      <div className="activity-card-wrapper">
        <div className="activity_select_top_block builder_form" style={{ width: "100%", margin: "0px auto" }}>
          <div className="d_flex flex_column gap_3 py_3" style={{ marginBottom: "0px" }}>
            <Input
              type="checkbox"
              name="type"
              checked={activityData.type === "init"}
              onChange={settingTypeChange}
              label="Init"
            />
            <Input
              type="number"
              name="allowed_count"
              value={activityData.allowed_count}
              onChange={handleChangeAllowedCount}
              label="MAX attempts allowed"
            />
          </div>
        </div>
        <div className="owner_assignment_container">
          <div style={{ position: "relative" }}>
            <div
              className="activity_select_top_block" //DESC ASC
              style={{ width: "100%", margin: "53px auto 20px auto", padding: "20px" }}
            >
              <label className="section_sub_heading">Sort Field</label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px"
                }}
              >
                <SingleSelectBox
                  selectedData={activityData.sort_by.key}
                  options={activityForm.sections[0].fields || []}
                  labelKey={["label"]}
                  onChange={(obj) => handleChangeSortKey(obj.id)}
                  placeholder="Select Field"
                  label="Select Field"
                />
                <SingleSelectBox
                  selectedData={activityData.sort_by.order}
                  options={sortOrderOptions}
                  onChange={(obj) => handleChangeSortOrder(obj.id)}
                  placeholder="Select Order"
                  label="Select Order"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="owner_assignment_container">
          <div style={{ position: "relative" }}>
            <div
              className="activity_select_top_block builder_form"
              style={{ width: "100%", margin: "53px auto 20px auto" }}
            >
              <label className="section_sub_heading">Owner Assignment</label>
              <div className="form_edit_del_buttons">
                <button
                  className="builder_action_btn  edit"
                  title=""
                  style={{ width: "32px", height: "32px", fontsize: "20px" }}
                  onClick={() => openSidebar("Owner Assignment", "owner_assignment")}
                >
                  <span className="material-symbols-outlined" style={{ fontsize: "20px" }}>
                    edit
                  </span>
                </button>
              </div>
              <div className="overlay_cover"></div>
              <OwnerAssignmentCard
                ownerAssignment={activityData.activity_owner_assignment}
                allGroups={allGroups}
                // allCommunityGroups={allCommunityGroups}
                allRdbms={allRdbms}
              />
            </div>
          </div>
        </div>
        <div className="owner_assignment_container">
          <div style={{ position: "relative" }}>
            <div
              className="activity_select_top_block builder_form"
              style={{ width: "100%", margin: "53px auto 20px auto" }}
            >
              <label className="section_sub_heading">Advanced Permission</label>
              <div className="form_edit_del_buttons">
                <button
                  className="builder_action_btn  edit"
                  title=""
                  style={{ width: "32px", height: "32px", fontsize: "20px" }}
                  onClick={() => openSidebar("Perfomed Logic", "performed_logic")}
                >
                  <span className="material-symbols-outlined" style={{ fontsize: "20px" }}>
                    edit
                  </span>
                </button>
              </div>
              <div className="overlay_cover"></div>
              <RulePreview logic={activityData.activity_performed_logic} smId={smId} />
            </div>
          </div>
        </div>
        <SuccessError data={activityData.activity_response} onChange={handleMessageChange} tableID={smId} />
      </div>
      <BuilderRightSideBar isOpen={sidebarModal.isOpen} heading={sidebarModal.title} onClose={closeSidebar}>
        {sidebarModal.type === "owner_assignment" && (
          <OwnerAssignment
            ownerAssignment={activityData.activity_owner_assignment}
            setOwnerAssignment={settingOwnerAssignment}
          />
        )}
        {sidebarModal.type === "performed_logic" && (
          <RuleBuilder
            logic={activityData.activity_performed_logic}
            onChange={(data) => {
              setActivityData({ ...activityData, activity_performed_logic: data });
            }}
            smId={smId}
          />
        )}
      </BuilderRightSideBar>
    </div>
  );
};

export const operatorForActivityPerfomedLogic = [
  { id: "==", label: "Equals" },
  { id: "!=", label: "Not Equals" },
  { id: ">", label: "Greater Than" },
  { id: "<", label: "Less Than" },
  { id: ">=", label: "Greater or Equal" },
  { id: "<=", label: "Less or Equal" },
  { id: "in", label: "In (value in array)" },
  { id: "contains", label: "Contains (array contains value)" },
  { id: "intersects", label: "Intersects (arrays overlap)" },
  { id: "subset", label: "Subset (all values contained)" }
];

// 🔹 Component for one rule
function RuleEditor({ rule, index, updateRule, removeRule, smId }) {
  const [arrayText, setArrayText] = useState(Array.isArray(rule.value) ? rule.value.join(",") : "");

  const handleOperatorChange = (e) => {
    const newOperator = e.target.value;
    updateRule(index, {
      ...rule,
      operator: newOperator,
      value: ""
    });
    setArrayText("");
  };

  const handleArrayChange = (e) => {
    setArrayText(e.target.value);
  };

  const commitArrayValue = () => {
    const arr = arrayText
      .split(",")
      .map((v) => v.trim())
      .filter((v) => v !== "");
    updateRule(index, { ...rule, value: arr });
  };

  const handleNormalChange = (e) => {
    updateRule(index, { ...rule, value: e.target.value.trim() });
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px", // slightly larger gap for breathing space
        marginBottom: "12px"
      }}
    >
      {/* Field Selector */}
      <div style={{ flex: 2, minWidth: "150px" }}>
        <FieldSelectorFromPopup
          tableId={smId}
          tableType="statemachine"
          onSelect={(fieldObj) => {
            updateRule(index, { field: fieldObj?.id, operator: "", value: "" });
          }}
          fieldId={rule.field}
        />
      </div>

      <div style={{ flex: 1, minWidth: "160px" }}>
        <SingleSelectBox
          options={operatorForActivityPerfomedLogic}
          valueKey="id"
          labelKey="label"
          selectedData={rule.operator}
          onChange={(op) => handleOperatorChange({ target: { value: op.id } })}
          isSearch
          placeholder="Select Operator"
        />
      </div>

      <div style={{ flex: 3, minWidth: "200px" }}>
        {["in", "intersects", "subset"].includes(rule.operator) ? (
          <Input
            type="text"
            value={arrayText}
            onChange={handleArrayChange}
            onBlur={commitArrayValue}
            placeholder="comma,separated,values"
            style={{ padding: "6px", width: "100%" }}
            disabled={!rule.operator}
          />
        ) : (
          <Input
            type="text"
            value={rule.value}
            onChange={handleNormalChange}
            placeholder={rule.operator === "contains" ? "Enter value to check in array" : "Enter value"}
            style={{ padding: "6px", width: "100%" }}
            disabled={!rule.operator}
          />
        )}
      </div>

      <div>
        <ButtonActionIcon type="delete" onClick={() => removeRule(index)} />
      </div>
    </div>
  );
}

function RuleBuilder({ logic, onChange, smId }) {
  const rules = logic?.rules || [];
  const addRule = () => {
    onChange({ ...logic, rules: [...rules, { field: "", operator: "", value: "" }] });
  };

  const updateRule = (index, newRule) => {
    const newRules = [...rules];
    newRules[index] = newRule;

    if (Array.isArray(newRule.value)) {
      newRules[index].value = newRule.value.filter((v) => v !== "");
    }

    onChange({ ...logic, rules: newRules });
  };

  const removeRule = (index) => {
    onChange({ ...logic, rules: rules.filter((_, i) => i !== index) });
  };

  return (
    <div style={{ padding: "16px", fontFamily: "sans-serif" }}>
      {rules.map((rule, index) => (
        <RuleEditor key={index} rule={rule} index={index} updateRule={updateRule} removeRule={removeRule} smId={smId} />
      ))}

      <div className="d_flex justify_end">
        <Button onClick={addRule}> + Add Rule</Button>
      </div>
    </div>
  );
}

const operatorLabels = {
  "==": "equals",
  "!=": "not equals",
  ">": "greater than",
  "<": "less than",
  ">=": "greater or equal",
  "<=": "less or equal",
  in: "in",
  contains: "contains",
  intersects: "intersects",
  subset: "subset"
};

function RulePreview({ logic, smId }) {
  const { getTableTypeData } = useTableContext();
  const [tableObj, setTableObj] = useState(null);
  useEffect(() => {
    const fetchTable = async () => {
      try {
        let { tableObject } = await getTableTypeData("statemachine", smId);
        setTableObj(tableObject);
      } catch (error) {
        setTableObj(null);
      }
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!logic || !logic.rules || logic.rules.length === 0 || !tableObj) {
    return <div>No rules defined yet.</div>;
  }

  return (
    <div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {logic.rules.map((rule, index) => (
          <li
            key={index}
            style={{
              padding: "8px",
              marginBottom: "6px",
              borderRadius: "4px",
              background: "white",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
            }}
          >
            <strong style={{ color: "#333" }}>{tableObj[rule.field]?.display || "Unknown Field"}</strong>{" "}
            <span style={{ color: "#007acc" }}>{operatorLabels[rule.operator] || rule.operator}</span>{" "}
            <span style={{ color: "#444" }}>
              {Array.isArray(rule.value) ? rule.value.join(", ") : rule.value?.toString()}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
export default ActivitySettings;
